export default __webpack_public_path__ + "static/media/failedIcon.7f43880b.svg";